// Utility to clean up stale notifications on app startup
import notificationService from '../services/notificationService';

export const cleanupStaleNotificationsOnStartup = () => {
  try {
    console.log('🧹 Cleaning up stale notifications on app startup...');
    const removedCount = notificationService.forceCleanupStaleNotifications();
    
    if (removedCount > 0) {
      console.log(`✅ Removed ${removedCount} stale notifications from previous sessions`);
    } else {
      console.log('✅ No stale notifications found');
    }
    
    return removedCount;
  } catch (error) {
    console.error('❌ Error cleaning up stale notifications:', error);
    return 0;
  }
};

export default {
  cleanupStaleNotificationsOnStartup
};
